export default __webpack_public_path__ + "static/media/profile9.ed1cb5bd.png";